import { DialogBody }                      from '@/components/ui/dialog'
import { DialogCloseTrigger }              from '@/components/ui/dialog'
import { DialogContent }                   from '@/components/ui/dialog'
import { DialogHeader }                    from '@/components/ui/dialog'
import { DialogRoot }                      from '@/components/ui/dialog'
import { DialogTitle }                     from '@/components/ui/dialog'
import { Dispatch }                        from 'react'
import { SetStateAction }                  from 'react'
import { useTranslation }                  from 'react-i18next'
import { Stack }                           from '@chakra-ui/react';
import { Text }                            from '@chakra-ui/react';
import { Input }                           from '@chakra-ui/react';
import { Field }                           from '@/components/ui/field';
import { useForm }                         from 'react-hook-form';
import { Button }                          from '@/components/ui/button';
import ClaimByCodeModel                    from '@/models/services/gespass/ClaimByCodeModel';
import { toaster }                         from '@/components/ui/toaster';
import DeliverableTransferClaimByCodeModel from '@/models/services/shop/DeliverableTransferClaimByCodeModel.ts';

type AddTicketModalProps = {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	onSuccess: () => void;
}

type FormValues = {
	code: string;
}

export default function AddTicketModal(props: AddTicketModalProps) {
	const { isOpen, setIsOpen } = props;

	const { t } = useTranslation();

	const {
		formState: { isSubmitting },
		handleSubmit,
		register,
	} = useForm<FormValues>();

	const onSubmit = handleSubmit(async (data) => {
		try {
			const { code } = data;

			const model = code.startsWith('GPA/') ?
				new ClaimByCodeModel() :
				new DeliverableTransferClaimByCodeModel();

			await model.patch({ value: code });

			setIsOpen(false);

			props.onSuccess();

		} catch (err) {
			toaster.create({ title: t('pages.tickets.addTicket.form.errors.title'), type: 'error' });
			console.error(err);
		}
	});

	return (
		<DialogRoot open={isOpen} size={{ base: 'xs', lg: 'lg' }}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t('pages.tickets.addTicket.form.title')}</DialogTitle>
				</DialogHeader>

				<DialogBody pb="4">
					<form onSubmit={onSubmit}>
						<Stack gap="20px" marginTop="20px">
							<Field
								label={
									<Text className="poppins-semibold" fontSize="14px" fontWeight="bold">
										{t('pages.tickets.addTicket.form.code')}
									</Text>
								}
								required
							>
								<Input
									placeholder={t('pages.tickets.addTicket.form.code')}
									{...register('code', { required: true })}
								/>
							</Field>

							<Button
								loading={isSubmitting}
								mt={8}
								type="submit"
								variant="solid"
							>
								{t('pages.tickets.addTicket.form.ok')}
							</Button>
						</Stack>
					</form>
				</DialogBody>

				<DialogCloseTrigger onClick={() => setIsOpen(false)} />
			</DialogContent>
		</DialogRoot>
	);
}